(() => {
  const main=document.querySelector('#MainContent');
  if(!main)return;
  const media=matchMedia('(max-width: 768px)');
  let originals=[],open=false,moving=false;
  const story=document.createElement('button');story.type='button';story.className='nb-story-toggle';story.textContent=main.dataset.nbStoryLabel;
  const nav=document.createElement('nav');nav.className='nb-jumpnav';nav.setAttribute('aria-label',main.dataset.nbPageLabel);
  function update(recapture=false){
    if(moving)return;moving=true;
    const sections=[...main.children].filter(el=>el.querySelector('[data-nb-role]'));
    if(!originals.length||recapture&&!media.matches)originals=sections;
    else if(recapture){
      const current=new Map(sections.map(el=>[el.id,el]));
      originals=originals.map(el=>current.get(el.id)).filter(Boolean);
      for(const el of sections)if(!originals.includes(el))originals.push(el);
    }
    const details=el=>el.querySelector('[data-nb-role]');
    nav.replaceChildren();
    for(const [role,label] of [['feeding','dosage'],['ingredients','ingredients'],['faq','faq']]){
      const node=sections.find(el=>details(el).dataset.nbRole===role),anchor=node&&details(node);
      if(anchor?.id){const a=document.createElement('a');a.href=`#${anchor.id}`;a.textContent=anchor.dataset.jumpLabel;nav.append(a);}
      if(role==='feeding'&&node){const target=node.querySelector('[data-label-anchor]')||node.querySelector('.nb-feeding>div[id]');if(target){const a=document.createElement('a');a.href=`#${target.id}`;a.textContent=target.dataset.label|| main.dataset.nbLabel;nav.append(a);}}
    }
    const history=sections.filter(el=>details(el).dataset.story==='true');
    story.hidden=!history.length;story.setAttribute('aria-expanded',String(open));story.setAttribute('aria-controls',history.map(el=>el.id).join(' '));
    if(media.matches){
      const ordered=[...sections].sort((a,b)=>Number(details(a).dataset.mobileOrder)-Number(details(b).dataset.mobileOrder));
      for(const node of ordered){
        const data=details(node).dataset;
        node.classList.toggle('nb-mobile-hidden',data.mobileHide==='true'||(data.story==='true'&&!open));
        main.append(node);
      }
      const hero=ordered.find(el=>details(el).dataset.nbRole==='hero');if(hero)hero.after(nav);
      if(history.length){const first=ordered.find(el=>details(el).dataset.story==='true');first.before(story);}else story.remove();
    }else{nav.remove();story.remove();for(const node of originals){node.classList.remove('nb-mobile-hidden');main.append(node);}}
    moving=false;
  }
  story.addEventListener('click',()=>{open=!open;update();});media.addEventListener('change',()=>update());
  document.addEventListener('shopify:section:load',()=>update(true));document.addEventListener('shopify:section:unload',()=>setTimeout(()=>update(true),0));
  document.addEventListener('shopify:section:reorder',()=>{if(!media.matches)update(true);else update();});
  document.addEventListener('shopify:section:select',event=>{if(event.target.querySelector('[data-story="true"]')){open=true;update();}});
  update();
})();

// Local interactions are initialized independently, including after Theme Editor reloads.
(() => {
  const mobile = matchMedia('(max-width: 768px)');
  const cleanups = new Map();
  function initialize(root = document) {
    root.querySelectorAll('.nb-language').forEach(form => {
      if (cleanups.has(form)) return;
      const abort = new AbortController();
      cleanups.set(form, () => abort.abort());
      form.addEventListener('submit', event => {
        const button = event.submitter;
        if (!button?.matches('button[name="language_code"]') || button.disabled) return;
        // Give immediate feedback without changing Shopify's native form submission.
        form.classList.add('is-switching');
        form.querySelectorAll('button').forEach(option => {
          option.classList.toggle('is-selected', option === button);
        });
      }, {signal: abort.signal});
    });
    root.querySelectorAll('.nb-formula-nav').forEach(switcher => {
      const current = switcher.querySelector('[aria-current]');
      if (!current || switcher.scrollWidth <= switcher.clientWidth) return;
      const offset = current.getBoundingClientRect().left - switcher.getBoundingClientRect().left;
      switcher.scrollLeft += offset - (switcher.clientWidth - current.clientWidth) / 2;
    });
    root.querySelectorAll('[data-nb-ingredients]').forEach(group => {
      if (group.dataset.initialized) return;
      group.dataset.initialized = 'true';
      const abort = new AbortController();
      cleanups.set(group, () => {abort.abort();delete group.dataset.initialized;});
      const buttons = [...group.querySelectorAll('.nb-ingredient-select')];
      const panels = [...group.querySelectorAll('.nb-ingredient-panel')];
      const toggle = group.querySelector('.nb-ingredient-toggle');
      let selected = 0;
      function update() {
        buttons.forEach((button, index) => {
          const active = index === selected;
          button.setAttribute('aria-expanded', String(active));
          button.parentElement.classList.toggle('is-selected', active);
          const description = button.querySelector('.nb-ingredient-description');
          if (description) {
            description.id = `${panels[index].id}-description`;
            button.setAttribute('aria-controls', mobile.matches ? description.id : panels[index].id);
          }
          panels[index].hidden = !active;
        });
      }
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        selected = mobile.matches && selected === index ? -1 : index;
        update();
      }, {signal:abort.signal}));
      toggle.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
      }, {signal:abort.signal});
      mobile.addEventListener('change', () => { if (selected < 0) selected = 0; update(); }, {signal:abort.signal});
      update();
    });
    root.querySelectorAll('.nb-menu-toggle').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      const abort = new AbortController();
      cleanups.set(button, () => {abort.abort();delete button.dataset.initialized;});
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      const close = (restoreFocus = false) => {
        button.setAttribute('aria-expanded', 'false'); menu.hidden = true;
        if (restoreFocus) button.focus();
      };
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded)); menu.hidden = !expanded;
      }, {signal:abort.signal});
      menu.addEventListener('click', event => { if (event.target.closest('a')) close(); }, {signal:abort.signal});
      button.closest('header').addEventListener('keydown', event => { if (event.key === 'Escape') close(true); }, {signal:abort.signal});
      mobile.addEventListener('change', () => close(), {signal:abort.signal});
    });
    root.querySelectorAll('[data-nb-availability]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const note = button.closest('.nb-buy').querySelector('.nb-availability-note');
        note.hidden = false; note.setAttribute('role', 'status');
      });
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-nb-reveal-story]');
    if (!link || !mobile.matches) return;
    const toggle = document.querySelector('.nb-story-toggle');
    if (toggle?.getAttribute('aria-expanded') === 'false') toggle.click();
  });
  const wrapper = document.querySelector('.page-wrapper');
  const updateBar = () => {
    const hero = document.querySelector('[data-nb-role="hero"]');
    const bar = document.querySelector('.nb-sticky-buy');
    if (hero && bar) bar.classList.toggle('is-visible', mobile.matches && hero.getBoundingClientRect().bottom < 100);
  };
  wrapper?.addEventListener('scroll', updateBar, {passive: true});
  window.addEventListener('scroll', updateBar, {passive: true});
  mobile.addEventListener('change', updateBar);
  mobile.addEventListener('change', () => initialize());
  window.addEventListener('pageshow', () => {
    // A Back/Forward cache restore must show the language of the restored page.
    document.querySelectorAll('.nb-language.is-switching').forEach(form => {
      form.classList.remove('is-switching');
      form.querySelectorAll('.is-selected').forEach(button => button.classList.remove('is-selected'));
    });
  });
  document.addEventListener('shopify:section:load', event => {initialize(event.target);updateBar();});
  document.addEventListener('shopify:section:unload', event => {for(const [node,cleanup]of cleanups)if(event.target.contains(node)){cleanup();cleanups.delete(node);}});
  initialize();updateBar();
})();
